// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c205EvzPWFKw3AqGn5BE {
  z-index: 1300;
  
  }  
  .sbZP3aMd9wHHB5ze1idC {
    color: white;
    background-color: #50a0d9;
    font-size: 12px;
    padding: 2px;
    padding-left: 14px;
    font-family: 'Poppins', sans-serif;
    z-index: 5;
   
   
  }
  .C1MzyB9ZD05ko49HR_NI{
    font-size: 12px;  
    padding: 0px;
    padding-left: 14px;    
    font-family: 'Poppins', sans-serif; 

  }
  .TYwYUfXzIL16S8V9XUZn {
    font-size: 14px;
    color: grey;
    padding: 0px;
    padding-left: 14px;   
    background-color: #f2f5f5;
    font-family: 'Poppins', sans-serif; 

  }
  `, "",{"version":3,"sources":["webpack://./src/components/MuiTable/muitable.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;;EAEb;EACA;IACE,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,UAAU;;;EAGZ;EACA;IACE,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;;EAEpC;EACA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kCAAkC;;EAEpC","sourcesContent":[".tableHead {\r\n  z-index: 1300;\r\n  \r\n  }  \r\n  .tableHeadCell {\r\n    color: white;\r\n    background-color: #50a0d9;\r\n    font-size: 12px;\r\n    padding: 2px;\r\n    padding-left: 14px;\r\n    font-family: 'Poppins', sans-serif;\r\n    z-index: 5;\r\n   \r\n   \r\n  }\r\n  .tablebody{\r\n    font-size: 12px;  \r\n    padding: 0px;\r\n    padding-left: 14px;    \r\n    font-family: 'Poppins', sans-serif; \r\n\r\n  }\r\n  .tablebodyWithChecked {\r\n    font-size: 14px;\r\n    color: grey;\r\n    padding: 0px;\r\n    padding-left: 14px;   \r\n    background-color: #f2f5f5;\r\n    font-family: 'Poppins', sans-serif; \r\n\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableHead": `c205EvzPWFKw3AqGn5BE`,
	"tableHeadCell": `sbZP3aMd9wHHB5ze1idC`,
	"tablebody": `C1MzyB9ZD05ko49HR_NI`,
	"tablebodyWithChecked": `TYwYUfXzIL16S8V9XUZn`
};
export default ___CSS_LOADER_EXPORT___;
